import { Component, OnInit, Input } from '@angular/core';
import { CalendarNotificationService } from 'src/app/services/service.index';
import { CNNotification } from 'src/app/models/cnnotification.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-calendar-notification',
  templateUrl: './calendar-notification.component.html',
  styleUrls: []
})
export class CalendarNotificationComponent implements OnInit {

  constructor(private calendarNotificationService: CalendarNotificationService) { }

  @Input() calendarNotification1: CNNotification;
  @Input() calendarNotification2: CNNotification;
  @Input() calendarNotification3: CNNotification;
  @Input() calendarNotification4: CNNotification;

  hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

  time = 0;

  ngOnInit(): void {
    console.log(this.calendarNotification1);
    this.time = this.calendarNotification1.mondayTime;
  }

  setCalendarNotification(notification: CNNotification) {
    if (notification.monday) {
      notification.time = notification.mondayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('1', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('1', this.prepareForSet(notification));
    }
    if (notification.tuesday) {
      notification.time = notification.tuesdayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('2', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('2', this.prepareForSet(notification));
    }
    if (notification.wednesday) {
      notification.time = notification.wednesdayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('3', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('3', this.prepareForSet(notification));
    }
    if (notification.thursday) {
      notification.time = notification.thursdayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('4', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('4', this.prepareForSet(notification));
    }
    if (notification.friday) {
      notification.time = notification.fridayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('5', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('5', this.prepareForSet(notification));
    }
    if (notification.saturday) {
      notification.time = notification.saturdayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('6', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('6', this.prepareForSet(notification));
    }
    if (notification.sunday) {
      notification.time = notification.sundayTime;
      notification.enabled = true;
      this.calendarNotificationService.setCalendar('0', this.prepareForSet(notification));
    } else {
      notification.enabled = false;
      this.calendarNotificationService.setCalendar('0', this.prepareForSet(notification));
    }
    Swal.close();
    Swal.fire('Se han guardado los cambios!',
      'El calendario se ha guardado exitosamente.', 'success');
  }

  prepareForSet(notification: CNNotification) {
    switch (notification.id) {
      case 'Notification1':
        const not1 = {
          Notification1: {
            description: notification.description,
            title: notification.title,
            onlyActive: notification.onlyActive,
            time: notification.time,
            enabled: notification.enabled
          }
        };
        return not1;
      case 'Notification2':
        const not2 = {
          Notification2: {
            description: notification.description,
            title: notification.title,
            onlyActive: notification.onlyActive,
            time: notification.time,
            enabled: notification.enabled
          }
        };
        return not2;
      case 'Notification3':
        const not3 = {
          Notification3: {
            description: notification.description,
            title: notification.title,
            onlyActive: notification.onlyActive,
            time: notification.time,
            enabled: notification.enabled
          }
        };
        return not3;
      case 'Notification4':
        const not4 = {
          Notification4: {
            description: notification.description,
            title: notification.title,
            onlyActive: notification.onlyActive,
            time: notification.time,
            enabled: notification.enabled
          }
        };
        return not4;
      default:
        return {
          Notification4: {
            description: '',
            title: '',
            onlyActive: false,
            time: '',
            enabled: false
          }
        };
    }
  }
}
